// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Hero_blockWrapper__0kTJ3","blockWrapperVisual":"Hero_blockWrapperVisual__X6UZF","image":"Hero_image__iq2eD"};